import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=ed06aab4&scoped=true"
import script from "./login2.vue?vue&type=script&lang=ts"
export * from "./login2.vue?vue&type=script&lang=ts"
import style0 from "./login2.vue?vue&type=style&index=0&id=ed06aab4&prod&lang=scss"
import style1 from "./login2.vue?vue&type=style&index=1&id=ed06aab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06aab4",
  null
  
)

export default component.exports